// 每日新增統計
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Form, Button, Radio, Table, Row, Col, DatePicker } from 'antd';

import PageHeaderLayout from '../../component/page-header-layout/index';

import './caixmPhone.less';
import { API_ADMIN } from '../../utils/urls';
import { generalParamsWithPToStr } from '../../utils/math';

import { getDailyBussinessStall } from '../../state/action/caixm';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;

const dateFormat = 'YYYY-MM-DD';
// 系统类型
const stallTypeSource = [
  { label: '正式专业版', value: 2 },
  { label: '正式基础版', value: 1 },
];
let pagination = {
  pageSize: 10,
  total: 0,
  current: 1,
};
@connect(
  (state) => {
    return { caixm: state.caixm };
  },
  { getDailyBussinessStall },
)
@Form.create()
class DailyBusinessStall extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.startDate = moment().startOf('month');
    this.endDate = moment().endOf('month');
  }
  componentDidMount() {
    this.dailyBussinessStall({
      stallType: 2,
      startTime: this.startDate.valueOf(),
      endTime: this.endDate.valueOf(),
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
  }

  async dailyBussinessStall(params) {
    this.setState({ loading: true });
    await this.props.getDailyBussinessStall(params);
    this.setState({ loading: false });
  }

  // 重置按钮
  handleReset = () => {
    this.props.form.resetFields();
    pagination.current = 1;
    this.props.form.validateFields((_, fieldsValue) => {
      let startTime = !fieldsValue.selectTime.length
        ? undefined
        : fieldsValue.selectTime[0].valueOf();
      let endTime = !fieldsValue.selectTime.length
        ? undefined
        : fieldsValue.selectTime[1].valueOf();
      let params = {
        stallType: fieldsValue.stallType,
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
      };
      if (startTime) {
        params.startTime = startTime;
      }
      if (endTime) {
        params.endTime = endTime;
      }
      this.dailyBussinessStall(params);
    });
  };

  // 查询
  handleSearch = (e) => {
    e.preventDefault();
    const { dailBussinessStallParams } = this.props.caixm;
    this.props.form.validateFields((_, fieldsValue) => {
      let startTime = !fieldsValue.selectTime.length
        ? undefined
        : fieldsValue.selectTime[0].valueOf();
      let endTime = !fieldsValue.selectTime.length
        ? undefined
        : fieldsValue.selectTime[1].valueOf();
      let params = {
        pageNo: dailBussinessStallParams.pageNo,
        pageSize: dailBussinessStallParams.pageSize,
        stallType: fieldsValue.stallType,
      };
      if (startTime) {
        params.startTime = startTime;
      }
      if (endTime) {
        params.endTime = endTime;
      }
      this.dailyBussinessStall(params);
    });
  };
  // 分页
  paginationChange = (e) => {
    pagination.current = e.current;
    const { dailBussinessStallParams } = this.props.caixm;
    this.dailyBussinessStall({
      ...dailBussinessStallParams,
      pageNo: pagination.current,
    });
  };

  // 导出
  exportData = () => {
    this.props.form.validateFields((_, fieldsValue) => {
      let params = {
        stallType: fieldsValue.stallType,
        startTime: fieldsValue.selectTime[0].valueOf(),
        endTime: fieldsValue.selectTime[1].valueOf(),
      };
      window.open(
        `${API_ADMIN}dailyTradingStatistics/exportTradingStatistics?${generalParamsWithPToStr(
          'dailyTradingStatistics/exportTradingStatistics',
          params,
        )}`,
      );
    });
  };

  exportDailyAddStall = (params) => {
    this.props.exportDailyAddStall(params);
  };

  render() {
    const { loading } = this.state;
    const layout = { xs: 24, sm: 12, md: 8, lg: 8, xl: 8 };
    const { getFieldDecorator } = this.props.form;
    const {
      caixm: { dailyBussinessStall = {} },
    } = this.props;
    const { pageNo = 1, totalSize = 1, pageList = [] } = dailyBussinessStall;
    pagination = {
      pageSize: 10,
      total: totalSize,
      current: pageNo,
    };
    const columns = [
      {
        title: '日期',
        dataIndex: 'orderTime',
        render: (_, record) => {
          return moment(new Date(record.orderTime)).format(dateFormat);
        },
      },
      {
        title: '开单商行数',
        key: 'billingStallCount',
        dataIndex: 'billingStallCount',
      },
      {
        title: '订单总数',
        key: 'totalOrderCount',
        dataIndex: 'totalOrderCount',
      },
      {
        title: '平均开单量',
        key: 'avgBillingCount',
        dataIndex: 'avgBillingCount',
      },
      {
        title: 'GMV',
        key: 'gmv',
        dataIndex: 'gmv',
      },
      {
        title: '赊欠订单数',
        key: 'creditOrderCount',
        dataIndex: 'creditOrderCount',
      },
      {
        title: '赊欠金额',
        key: 'creditAmount',
        dataIndex: 'creditAmount',
      },
    ];
    return (
      <PageHeaderLayout>
        <div className='caixm-phone'>
          <div className='extraContent' style={{ width: '100%' }}>
            <Form className='ant-advanced-search-form' onSubmit={this.handleSearch}>
              <Col {...layout}>
                <FormItem label='系统类型'>
                  {getFieldDecorator('stallType', {
                    initialValue: stallTypeSource[0].value,
                  })(
                    <Radio.Group>
                      <Radio value={stallTypeSource[0].value}>{stallTypeSource[0].label}</Radio>
                      <Radio value={stallTypeSource[1].value}>{stallTypeSource[1].label}</Radio>
                    </Radio.Group>,
                  )}
                </FormItem>
              </Col>
              <Row gutter={24}>
                <Col {...layout}>
                  <FormItem label='日期'>
                    {getFieldDecorator('selectTime', {
                      initialValue: [
                        moment(this.startDate, dateFormat),
                        moment(this.endDate, dateFormat),
                      ],
                      rules: [],
                    })(<RangePicker format='YYYY-MM-DD' placeholder={['开始时间', '结束时间']} />)}
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24}>
                  <FormItem>
                    <Button type='primary' htmlType='submit' style={{ marginTop: '20px' }}>
                      查询
                    </Button>
                    <Button
                      style={{ marginLeft: '20px', marginTop: '20px' }}
                      onClick={this.handleReset}
                    >
                      重置
                    </Button>
                    <Button
                      style={{ marginLeft: '20px', marginTop: '20px' }}
                      onClick={this.exportData}
                    >
                      导出
                    </Button>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </div>
          <Table
            dataSource={pageList}
            columns={columns}
            pagination={pagination}
            rowKey={(record) => record.id}
            align='center'
            onChange={this.paginationChange}
            loading={loading}
          />
        </div>
      </PageHeaderLayout>
    );
  }
}
export default DailyBusinessStall;
